<template>
  <div>
    <Banner :classType="4" />
    <AboutMenu
      :menu="[
        { name: '党建要闻', url: '/party/important' },
        { name: '基层党建', url: '/party/foundation' },
        { name: '监督执纪', url: '/party/watch' },
        { name: '群团工作', url: '/party/team' },
      ]"
    />

    <div class="pageTitle wow animate__slideInUp">
      <h2>{{ titleObj[type].name }}</h2>
      <p>{{ titleObj[type].enName }}</p>
    </div>

    <div class="partyBox wrap wow animate__slideInUp">
      <div class="partyR">
        <NewsList2 :newsList="newsList" />
        <div class="pageBox" v-if="showPage">
          <Pagination @pageChange="getNewsList" :PagingInfo="PagingInfo" />
        </div>
      </div>
      <RightBook :TopNewsInfos="TopNewsInfos" />
    </div>
  </div>
</template>

<script>
import Banner from "@/views/components/Banner";

import AboutMenu from "./components/AboutMenu";
import NewsList2 from "./components/NewsList2";
import RightBook from "./components/RightBook";
import { WOW } from "wowjs";
import Pagination from "@/views/components/Pagenation";

export default {
  data() {
    return {
      type: this.$route.query.type || "important",
      titleObj: {
        important: { name: "党建要闻", enName: "NEWS OF PARTY BUILDING" },
        foundation: { name: "基层党建", enName: "GRASSROOTS PARTY BUILDING" },
        watch: {
          name: "监督执纪",
          enName: "DISCIPLINES SUPERVISION AND EXECUTION",
        },
        team: { name: "群团工作", enName: "MASS ORGANIZATION WORKS" },
      },
      TopNewsInfos: [],
      newsList: [],
      newsType: "",
      PagingInfo: {},
      pageCur:1,
      showPage:false
    };
  },
  components: {
    AboutMenu,
    NewsList2,
    RightBook,
    Pagination,
    Banner,
  },
  methods: {
    getNewsList(page, type) {
      this.$api
        .newsList({
          Type: this.newsType,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { NewsItems, PagingInfo } = res.Value;
          this.newsList = NewsItems;
          this.PagingInfo = PagingInfo;
          this.showPage = true
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
    changeNewsType() {
      switch (this.type) {
        case "important":
          this.newsType = 5;
          break;
        case "foundation":
          this.newsType = 6;
          break;
        case "watch":
          this.newsType = 7;
          break;
        case "team":
          this.newsType = 8;
          break;
      }
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.type = this.$route.params.type;
        this.changeNewsType();
        this.getNewsList(1, "first");
      }
    );
  },
  beforeRouteEnter(to, from,next) {
    let fromURL = from.name
    next((vm)=>{
      if(fromURL == 'newsContent')
      vm.pageCur = sessionStorage.getItem('currentPage')
    })
  },
  mounted() {
    this.type = this.$route.params.type;
    this.changeNewsType();
    
    /* new WOW({
      boxClass: "wow",
      animateClass: "animate__animated",
      // offset: 100,
      live: false,
    }).init(); */
    this.$api
      .topNewsList({
        Type: "2",
      })
      .then((res) => {
        const { TopNewsInfos } = res.Value;
        this.TopNewsInfos = TopNewsInfos;
        this.$nextTick(() => {
          new WOW({
            boxClass: "wow",
            animateClass: "animate__animated",
            live: false,
          }).init();
        });
      });
      this.getNewsList(this.pageCur, "first");
  },
  
};
</script>

<style lang="scss">
.partyBox {
  padding: 50px 0 20px;
  display: grid;
  grid-template-columns: auto 280px;
  grid-gap: 20px 20px;
  .partyR {
    overflow: hidden;
  }
}
</style>